import styled from 'styled-components';

import { black, white } from '../../modules/colors';
import media from '../../modules/media';
import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.footer`
  background-color: ${black};
  color: ${white};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${spacing.lg}px;
  ${(props) => !props.noExtraSpace && 'margin-top: 100px'};
`;

export const Content = styled.div`
  max-width: 1440px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;

  > * {
    :last-child {
      margin-right: 0;
    }
  }

  ${media.phone} {
    flex-direction: column;
  }
`;

export const Company = styled.div`
  width: 50%;

  ${media.phone} {
    width: 100%;
  }
`;

export const CompanyInfo = styled.div`
  font-size: ${fonts.sm}px;
  margin-top: ${spacing.md}px;
  width: 70%;

  ${media.phone} {
    width: 100%;
  }
`;

export const Brand = styled.div`
  display: inline-flex;
  font-size: ${fonts.xl}px;
  color: ${white};
  align-items: center;
  margin-bottom: ${spacing.lg}px;
`;

export const Logo = styled.img`
  height: 56px;
  margin-right: ${spacing.lg}px;
`;

export const Info = styled.div`
  width: 16%;
  margin-right: ${spacing.lg}px;

  ${media.phone} {
    width: 100%;
    margin-top: ${spacing.lg}px;
    margin-right: 0;
  }
`;

export const Title = styled.div`
  font-size: ${fonts.lg}px;
  padding: ${spacing.lg}px 0;
  font-weight: 500;

  ${media.tablet} {
    font-size: ${fonts.md}px;
  }

  ${media.phone} {
    font-size: ${fonts.lg}px;
    padding: ${spacing.md}px 0;
  }
`;

export const Details = styled.a`
  display: flex;
  flex-direction: column;
  font-size: ${fonts.sm}px;
  padding-top: ${spacing.md}px;

  :hover {
    opacity: 0.7;
    transition: opacity 0.5s ease 0s;
    cursor: pointer;
  }
`;

export const Line = styled.hr`
  color: white;
  margin: ${spacing.lg}px 0;
`;

export const Rights = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${fonts.sm}px;
`;

export const Iso = styled.img`
  height: 100px;
  margin-top: ${spacing.md}px;
`;
